export default "__VITE_ASSET__3c8ad4f2__"